export default {
  h1: {
    fontWeight: 600,
    fontSize: 50,
    letterSpacing: '5px'
  },
  h2: {
    fontWeight: 700,
    fontSize: 40,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: 40,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px'
  },
  subtitle1: {
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
  caption: {
    fontSize: 10
  },
  fontFamily: [
    'Roboto'
  ].join(','),
};
